/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import getAttributesForSelectedVariant, { AttributesForSelectedVariantInput } from './dataActions/get-attributes-for-selected-variant';
import ProductSpecification from './modules/product-specification/product-specification';
import ProductSpecificationView from './modules/product-specification/product-specification.view';

export * from './modules/product-specification/components/product-specification-table-stucture';
export * from './modules/product-specification/product-specification';
export * from './modules/product-specification/product-specification.data';
export * from './modules/product-specification/product-specification.props.autogenerated';
export * from './modules/product-specification/product-specification.view';
export {
    AttributesForSelectedVariantInput,
    getAttributesForSelectedVariant,
    ProductSpecification,
    ProductSpecificationView };
